module.exports = file => () => import('@/container/' + file + '.vue')
